import { Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, IconButton, List, ListItem, MenuItem, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { formatoNum } from '../../lib/format';
import { Close, Folder, Save } from '@mui/icons-material';

const AntecedentesTab = ({ antecedentes, imagenes, editable, setData, handleUpdate }) => {
    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'antecedentes';
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                });
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (imgurl, isNew = false) => {
        setData({ target: { name: 'imagenes', value: imagenes.filter(img => (isNew ? img.dataurl : img.url_img) !== imgurl) } });
    }

    if (antecedentes) {
        return (
            <Box sx={{ m: 2 }}>
                <Grid container spacing={3} sx={{ my: 2 }}>
                    <Grid item xs={12}>
                        <Typography variant="h6">Fecha y lugar en que se estableció la empresa:</Typography>
                        {editable ?
                            <TextField fullWidth name="fecha_lugar_origen" defaultValue={antecedentes.fecha_lugar_origen} value={antecedentes.fecha_lugar_origen} onChange={setData} />
                            :
                            <Typography sx={{ mx: 1, mt: 2 }}>{antecedentes.fecha_lugar_origen}</Typography>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6">Origen de la organización:</Typography>
                        {editable ?
                            <TextField fullWidth name="origen_antecedentes" multiline rows={3} defaultValue={antecedentes.origen_antecedentes} value={antecedentes.origen_antecedentes} onChange={setData} />
                            :
                            <Typography sx={{ mx: 1, mt: 2 }}>{antecedentes.origen_antecedentes}</Typography>
                        }
                    </Grid>
                </Grid>
                <Divider />
                <Box sx={{ my: 2, display: { lg: 'flex', xs: 'block' } }}>
                    {/* Año de inicio */}
                    <Grid item xs={12} lg={3} sx={{ mr: 2 }}>
                        <Box sx={{ width: '100%' }}>
                            <Typography variant="h6" sx={{ mb: 2 }}>Año de inicio:</Typography>
                            {editable ?
                                <TextField name="fecha_inicio" defaultValue={antecedentes.fecha_inicio} value={antecedentes.fecha_inicio} onChange={setData} />
                                :
                                <Typography sx={{ mx: 1 }}>{antecedentes.fecha_inicio}</Typography>
                            }
                        </Box>
                    </Grid>
                    {/*  */}
                    {/* Socios de la organización en sus orígenes */}
                    <Grid item xs={12} lg={9} sx={{ width: '100%' }}>
                        <Box>
                            <Typography variant="h6" sx={{ mb: 2 }}>Socios de la organización en sus orígenes</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} lg>
                                    {editable ?
                                        <TextField label="Empresas sociales" name="cant_empresas_sociales" value={antecedentes.cant_empresas_sociales} onChange={setData} />
                                        :
                                        <>
                                            <Typography textAlign="center">Empresas sociales</Typography>
                                            <Typography textAlign="center" sx={{ mx: 1 }}>{formatoNum(antecedentes.cant_empresas_sociales)}</Typography>
                                        </>
                                    }
                                </Grid>
                                <Grid item xs={12} lg>
                                    {editable ?
                                        <TextField label="Organizaciones" name="cant_organizaciones" value={antecedentes.cant_organizaciones} onChange={setData} />
                                        :
                                        <>
                                            <Typography textAlign="center">Organizaciones</Typography>
                                            <Typography textAlign="center" sx={{ mx: 1 }}>{formatoNum(antecedentes.cant_organizaciones)}</Typography>
                                        </>
                                    }
                                </Grid>
                                <Grid item xs={12} lg>
                                    {editable ?
                                        <TextField label="Familias totales" name="cant_socios" value={antecedentes.cant_socios} onChange={setData} />
                                        :
                                        <>
                                            <Typography textAlign="center">Familias totales</Typography>
                                            <Typography textAlign="center" sx={{ mx: 1 }}>{formatoNum(antecedentes.cant_socios)}</Typography>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Box>
                <Divider />
                <Typography sx={{ my: 2 }} variant="h6">Fotogalería de las primeras sesiones de la empresa:</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    {!editable &&
                        <Grid container spacing={2}>
                            {Object.values(imagenes)
                                .filter((i) => i.paso === 'antecedentes')
                                .map((img, index) => {
                                    // console.log(Object.values(imagenes).filter((i) => i.paso === 'antecedentes'));
                                    return (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            key={index}
                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                        >
                                            <img
                                                src={img.url_img ?? img.dataurl}
                                                width="100%"
                                                alt={index}
                                                style={{ maxWidth: '300px', objectFit: 'contain' }}
                                            />
                                        </Grid>
                                    )
                                })}
                        </Grid>
                    }
                    {editable &&
                        <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                            {Object.values(imagenes).filter((i) => i.paso == 'antecedentes').map((image, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    key={index}
                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center' }}>
                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => image.url_img ? removeImg(image.url_img) : removeImg(image.dataurl, true)}>
                                        <Close />
                                    </IconButton>
                                    <img src={image.url_img ?? image.dataurl} alt={image.name} width="300px" />
                                </Grid>
                            ))}
                            <Grid item xs={12}>
                                <Button
                                    disabled={imagenes.filter((i) => i.paso == 'antecedentes').length > 2}
                                    component="label"
                                    variant="contained"
                                    startIcon={<Folder />}
                                >
                                    Agregar <input name="imagenes" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Box>

                {/* Boton para actualizar datos de este tab. (Excepto imagenes, se actualizaran al vuelo) */}
                {
                    editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                    </Box>
                }
            </Box >

        )
    }
}

export default AntecedentesTab;